import { ui } from '@beelday/common'
import styled from '@emotion/styled'
import { FC } from 'react'

/** The kit's primary button, made for the one thing the screen asks of the trainer. */
const Large = styled(ui.ButtonPrimary)`
	min-width: 260px;
	height: 56px;
	padding: 0 40px;
	font-size: 14px;
	letter-spacing: 0.04em;
`

type Props = {
	onClick: () => unknown
	testId: string
}

/** The trainer's one action on the lobby: Start the training, End the break. */
export const LobbyAction: FC<Props> = ({ onClick, testId, children }) => (
	<Large type="button" onClick={onClick} data-testid={testId}>
		{children}
	</Large>
)
